export default __webpack_public_path__ + "static/media/DSC05794.fd4a761e.jpg";